import React, { useEffect, useMemo, useState } from "react";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { ThemeProvider } from "@mui/material/styles";
import dayjs from "dayjs";
import useGetSearchParams from "../../hooks/useGetSearchParams";
import useSetSearchParams from "../../hooks/useSetSearchParams";
import { useSearchParams } from "react-router-dom";
import {
    datePickerDarkTheme,
    datePickerGreyThemeStyles,
    datePickerStyles,
    StyledDatePicker
} from "../../assets/styles/Themes/DatePickerTheme";

export const MuiDatePicker = ({
                                  label,
                                  searchParamValue,
                                  greyTheme = false,
                                  disableToday = false,
                              }) => {
    const params = useGetSearchParams();
    const [searchParams, setSearchParams] = useSearchParams();
    const updateSearchParams = useSetSearchParams(setSearchParams);

    const initialValue = useMemo(
        () => params[searchParamValue] || "",
        [params, searchParamValue]
    );

    const [selectedDate, setSelectedDate] = useState(
        initialValue ? dayjs(initialValue, "YYYY-MM-DD") : null
    );

    useEffect(() => {
        if (!initialValue) {
            setSelectedDate(null);
        }
    }, [initialValue]);

    const handleClear = () => {
        setSelectedDate(null);
        updateSearchParams(searchParamValue, "", true);
    };

    const today = dayjs().startOf("day");

    return (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <ThemeProvider theme={datePickerDarkTheme}>
                <StyledDatePicker
                    label={label}
                    value={selectedDate}
                    onChange={(newDate) => {
                        if (newDate && newDate.isValid()) {
                            setSelectedDate(newDate);
                            updateSearchParams(
                                searchParamValue,
                                newDate.format("YYYY-MM-DD")
                            );
                        }
                    }}
                    format="YYYY-MM-DD"
                    sx={greyTheme ? datePickerGreyThemeStyles : datePickerStyles}
                    slotProps={{
                        actionBar: {
                            actions: ["clear", "accept"],
                            onClear: handleClear,
                        },
                    }}
                    // забороняємо обрати сьогоднішню дату, якщо disableToday === true
                    shouldDisableDate={(date) =>
                        disableToday && date.startOf("day").isSame(today)
                    }
                />
            </ThemeProvider>
        </LocalizationProvider>
    );
};
